var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4746 5.40783L18.5916 7.52483M17.8356 3.54283L12.1086 9.26983C11.8118 9.56467 11.6099 9.94144 11.5286 10.3518L10.9996 12.9998L13.6476 12.4698C14.0576 12.3878 14.4336 12.1868 14.7296 11.8908L20.4566 6.16383C20.6287 5.99173 20.7652 5.78742 20.8584 5.56256C20.9515 5.33771 20.9995 5.09671 20.9995 4.85333C20.9995 4.60994 20.9515 4.36895 20.8584 4.14409C20.7652 3.91923 20.6287 3.71492 20.4566 3.54283C20.2845 3.37073 20.0802 3.23421 19.8554 3.14108C19.6305 3.04794 19.3895 3 19.1461 3C18.9028 3 18.6618 3.04794 18.4369 3.14108C18.212 3.23421 18.0077 3.37073 17.8356 3.54283Z",
    stroke: "black",
    strokeWidth: 1.97243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9996 15V18C18.9996 18.5304 18.7889 19.0391 18.4138 19.4142C18.0388 19.7893 17.5301 20 16.9996 20H5.99963C5.4692 20 4.96049 19.7893 4.58542 19.4142C4.21035 19.0391 3.99963 18.5304 3.99963 18V7C3.99963 6.46957 4.21035 5.96086 4.58542 5.58579C4.96049 5.21071 5.4692 5 5.99963 5H8.99963",
    stroke: "black",
    strokeWidth: 1.97243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlack);
export default __webpack_public_path__ + "static/media/EditIconBlack.e0626bd4980bf35cc0b9412b357936ce.svg";
export { ForwardRef as ReactComponent };